module.exports = __webpack_public_path__ + "static/media/goodglue.34fb6d3e.png";